import dayjsConfig from './dayjs';
import muiConfig from './material-ui';

export default function runConfig() {
  return {
    dayjs: dayjsConfig(),
    mui: muiConfig(),
  };
}
